import { styled } from '@mui/material';

import { popoverContentBodyClasses } from './theme';

import type { PopoverContentBodyProps } from './types';

const PopoverContentBody = (props: PopoverContentBodyProps) => {
  const { startIcon, endIcon, message } = props;

  if (!message) return null;

  return (
    <PopoverContentBodyRoot>
      {startIcon && <PopoverContentBodyStartIcon>{startIcon}</PopoverContentBodyStartIcon>}
      {message && <PopoverContentBodyMessage>{message}</PopoverContentBodyMessage>}
      {endIcon && <PopoverContentBodyEndIcon>{endIcon}</PopoverContentBodyEndIcon>}
    </PopoverContentBodyRoot>
  );
};

const PopoverContentBodyRoot = styled('div', {
  target: popoverContentBodyClasses.root,
})`
  display: flex;
  align-items: center;
  width: 100%;

  * + & {
    margin-top: 4px;
  }
`;

const PopoverContentBodyMessage = styled('div', {
  target: popoverContentBodyClasses.message,
})`
  width: 100%;
  max-width: 360px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #131619;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  * + & {
    margin-left: 4px;
  }
`;

const PopoverContentBodyStartIcon = styled('div', {
  target: popoverContentBodyClasses.startIcon,
})`
  width: 16px;
  height: 16px;
  font-size: 16px;
`;

const PopoverContentBodyEndIcon = styled('div', {
  target: popoverContentBodyClasses.endIcon,
})`
  width: 16px;
  height: 16px;
  font-size: 16px;

  * + & {
    margin-left: 4px;
  }
`;

export default PopoverContentBody;
